module.exports = __webpack_public_path__ + "static/img/llzj.018b99d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/llzj.png
// module id = 1240
// module chunks = 0